<template>
    <!-- 销售赎货预览 -->
    <div class="print">
        <div v-for="indx of printLength" :key="indx" :class="[indx != printLength?'printPageC':'',printLength > 1&&indx != printLength?'printPage':'','relative']">
            <!-- 头部打印修改处 START -->
            <img class="logoprint" src="../../../assets/logoPrint.png"/>
            <div class="companyTitle">{{printDetail.company_title}}</div>
            <div class="order_serial" v-if="(printDetail.fields).indexOf(',order_serial,')!=-1">{{printDetail.order_serial}}</div>
            <div class="tablePerson clearfix">
                <div class="personBox">
                    <div class="person">公司名称：{{printDetail.issuing}}</div>
                    <div class="person">赎货日期：{{printDetail.redeem_date | dateFormat}}</div>
                </div>
                <div class="personBox">
                    <div class="person">融资合同号：{{printDetail.contract_no}}</div>
                    <div class="person">赎货单号：{{printDetail.redeem_order_sn}}</div>
                </div>
            </div>
            <!-- 头部打印修改处 END -->
            <div class="tableBox printTableBox">
                <table class="table">
                    <thead>
                        <tr style="font-weight: bold;">
                            <td style="width:50px;">序号</td>
                            <td v-for="(list,index) in printDetail.column" :key="index" v-show="list.show">{{list.name}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(list, index) in printDetail.details" :key="index">
                            <td style="width:50px;">{{index + 1}}</td>
                            <td v-for="(column, colIndex) in printDetail.column" :key="colIndex">
                                {{list[column.key]}}
                            </td>
                        </tr>

                        <tr v-if="indx == printLength">
                            <td>合计</td>
                            <td v-for="(item,ind) in printTotal" :key="ind" :colspan="item.col">
                                {{item.content}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="amountWords" v-if="(printDetail.fields).indexOf(',amount_words,')!=-1">总价金额(大写)： {{printDetail.amount_words}}</div>
            </div>
            <!-- <div class="printLianBox clearfix">
                <div class="printLian" v-if="printLength > 1&& indx != printLength && category!=8">{{printDetail.union_pager}}</div>
                <div class="pageNumber" v-if="printLength > 1&& indx != printLength">当前第{{indx}}页/共{{printLength}}页</div>
            </div> -->

            <!-- 不同打印的分割线 -->
            <div v-if="indx != printLength" class="division"></div>
        </div>

        <!-- 底部打印修改处 START -->
        <div>
            <div class="printTotal clearfix totalItem capitalize">
                <div class="printTotalC">合计应付</div>
                <div class="printTotalC">赎货金额:{{printDetail.statistic.pay_redeem_amount}}</div>
            </div>
            <div class="printTotal clearfix totalItem capitalize">
                <div class="printTotalC">应付金额(大写):<span v-html="`&emsp;`"></span></div>
                <div class="printTotalC">{{printDetail.statistic.pay_redeem_amount_capital}}</div>
            </div> 
        </div>
        <!-- 底部打印修改处 END -->
        <div class="printLianBox clearfix">
            <!-- <div class="pageNumber">当前第{{printLength}}页/共{{printLength}}页</div> -->
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            companyName:localStorage.dw_erp_company_name,
            printLength:1,
            printLimit:20,
            printDetail:{
                fields:""
            },
            printTotal:[],
            id:"",
            category:"0"
        }
    },
    created(){
        this.id = sessionStorage.getItem('DEMU_ERP_ORDERSEE_ID');
        // this.category = this.$route.query.category;
        this.print()
    },
    methods:{
        print(){
            this.postFuncLoading("/erp/redeem.order.info.print ",{id:this.id},response=>{
                this.printDetail=response.data.data;
                // this.printLimit = parseInt(response.data.data.print_lines);
                this.printDetail.fields = ","+(this.printDetail.fields.join(",").toString())+",";
                // this.printLength = Math.ceil(this.printDetail.details.length / this.printLimit);
                this.printDetail.details.forEach((item,index)=>{
                    delete this.printDetail.details[index].status_text;
                })
                response.data.data.statistic.total_cube = this.keepLimit(response.data.data.statistic.total_cube)
                let arr = new Array();
                let objVal = new Object();
                objVal.col = 1;
                objVal.content = "";
                arr.push(objVal);
                let number = 0;
                let arrNum = 0;
                let flag = true;
                
                this.printDetail.column.forEach((item, index) => {
                    if (item.show) {
                        if (item.key == "original_cube" || item.key == "redeem_amount" || item.key == "interest") {
                            flag = false;
                            let obj = new Object();
                            obj.col = 1;
                            if (item.key == "original_cube") {
                                obj.content = this.keepLimit(response.data.data.statistic.redeem_cube);
                            } else if (item.key == "redeem_amount") {
                                obj.content = this.keepPrices(response.data.data.statistic.redeem_amount);
                            }else if (item.key == "interest") {
                                obj.content = this.keepPrices(response.data.data.statistic.interest);
                            }
                            arr.push(obj)
                            arr[arrNum].col = number;
                            arrNum++;
                            number = 0;
                            if (this.printDetail.column.length - 1 > index) {
                                let objC = new Object();
                                objC.col = 1;
                                objC.content = "";
                                arr.push(objC)
                                arrNum++;
                            }
                        } else {
                            number++;
                        }
                    }
                    if (this.printDetail.column.length - 1 == index) {
                        if (item.key != "original_cube" || item.key != "redeem_amount") {
                            arr[arr.length - 1].col = number;
                        }
                    }
                });
                if(flag){
                    arr[0].col = number;
                }
                arr.forEach((each,index)=>{
                    if(each.col == 0 && each.content == ''){
                        arr.splice(index,1);
                    }
                })
                this.printTotal = arr;
               
                // setTimeout(() => {
                //     this.printFunc();
                // }, 0);
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        printFunc(){
            if(!!window.netscape){
                window.print()
                setTimeout(()=>{window.close()}, 0);
            }else{
                var tata=document.execCommand("print");
                if(tata){
                    window.close()
                }
            }
        },
    }
}
</script>
<style scoped lang="scss">
    .print{position: relative;width: 800px;margin: 20px auto;padding: 20px; min-height: 100vh;box-sizing: border-box;display: block !important;background: #fff;}
    .print .pageNumber{font-size: 12px;text-align: center;height: 20px;line-height: 20px;float: right;}
    .print .printTable{position: relative;display: block;}
    .division{margin: 20px -20px 0 -20px;height: 20px;background: #EEEFF2;}
    .printPage{padding-bottom:25px;position: relative;box-sizing: border-box;}
    .relative{position: relative;}
    .logoprint{width:130px;position: absolute;top:0;left:0;}
    .law{padding-top:10px;padding-left:20px;position: relative;padding-bottom:5px;}
    .lawTextFu{position: absolute;top:10px;left:0;font-size:12px;}
    .lawText{font-size: 12px;margin-bottom:5px; text-align: left;}
    .blankMess td{font-size: 12px;border:1px solid #777;width:50%;padding:3px 10px;text-align: left;}
    .blankMess{border-collapse:collapse;width:100%;margin-top:10px; }
    .codeContent{display: flex;align-items: center;justify-content: space-between;}
    // .print{position: relative;}
    .print .specifications{text-align: left;font-size: 12px;padding:0 10px;box-sizing: border-box;}
    .print .title{font-size: 16px;font-weight: 600;padding-bottom:20px;}
    .print .companyTitle{font-size: 20px;font-weight: 600;padding-bottom:15px;text-align: center;height:40px;}
    // .print .tablePerson{}
    .print .personBox{float: left;}
    .print .personBox:nth-child(2n){float: right;}
    .print .personBox .person{text-align: left;}
    .print .personBox:nth-child(2n) .person{text-align: right;}
    .print .person{font-size: 14px;}
    .print .table td{font-size: 14px;padding:2px 0;border: 1px solid #777;box-sizing:content-box;}
    .print .table tr td:last-child{box-sizing: border-box;}
    .print .table{width:100%;border-collapse:collapse;}
    .print .remarkBox{width:100%;border:1px solid #777;border-top:0;box-sizing: border-box;padding:0 5px 0 40px;position: relative;}
    .print .remarkBox:before{content:"\5907\6CE8:";position: absolute;font-size: 12px;color: #777;top:2px;left:5px; }
    .print .remarkBox .remarkTextarea{width:100%;border:0;color:#777;min-height:25px;text-align: left;font-size: 12px;padding:3px 0;line-height: 15px;}
    .print .truckRemarkBox{width:100%;border:1px solid #777;border-top:0;box-sizing: border-box;padding:0 5px 0 60px;position: relative;}
    .print .truckRemarkBox:before{content:"\8F66\724C\5907\6CE8:";position: absolute;font-size: 12px;color: #777;top:2px;left:5px;font-weight: 600;}
    .print .truckRemarkBox .truckRemarkTextarea{width:100%;border:0;color:#777;min-height:25px;text-align: left;font-size: 12px;padding:3px 0;line-height: 15px;}
    .print .bottomMess:first-child{margin-top:5px;}
    .print .bottomMess{font-size: 12px;padding:2px 0;width:100%;}
    .print .bottomMessC{width:35%;float: left;text-align: left;}
    .print .bottomMessC:nth-child(3n){float: right;width:120px;margin-right:20%}
    .print .printTotal{width: 100%;border: 1px solid #777;border-top:0;text-align: right;}
    .print .totalItem{display: flex;flex-wrap: wrap;}
    .print .capitalize{display: block;}
    .print .printTotalC{font-size: 14px;font-weight: 600;margin-left: 10px;margin-right: 10px;line-height: 25px;display: inline;}
    .print .printTotalC:first-child{float: left;}
    .capitalizeC{font-size: 14px;font-weight: 600;margin-left: 10px;margin-right: 10px;line-height: 25px;display: inline; float: right;}
    td{text-align: center;}

    .print .bottomTwo .bottomMessC{width:35%!important;float: left;}
    .print .bottomTwo .bottomMessC:nth-child(2n){float: right;width:120px!important;margin-right:0;}

    .print .bottomThree .bottomMessC{width:30%!important;float: left;}
    .print .bottomThree .bottomMessC:nth-child(2n){float: left;width:20%!important;margin-right:0;}
    .print .bottomThree .bottomMessC:nth-child(3n){float: right;width:30%!important;margin-right:10%;}
    .print .bottom{position: relative;}
    .info_line{position: absolute;top:0;width:300px;text-align: center;font-size: 12px;padding:7px 0;left:20%;}
    .order_serial{font-size: 12px;position: absolute;top:10px;right:0;}
    .amountWords{font-size: 12px;border:1px solid #000;border-top:0;padding:5px 5px;text-align: left;}
    .bottomCategory8 .bottomMess{width:280px;}
    .bottomCategory8 .bottomMessC:nth-child(2n){width:280px;float: right;}
    .info_lineC .one_line{float: left;font-size: 12px;}
    .info_lineC .one_line:nth-child(2n){width:200px;float: right;}
    .titleAddress{border-bottom:1px solid #000;padding:5px 0;text-align: right;margin-bottom:10px;}
    .titleAddress span{font-size: 12px;margin-left:20px;}
</style>
